//#region src/utils/schema-sql-parser/utils.ts
function findByName(list, name) {
	for (const item of list) if (item.name.toUpperCase() === name.toUpperCase()) return item;
	return null;
}
//#endregion
export { findByName };
